import React, { useState } from "react";
import { TextField, Tooltip } from "@mui/material";
import { errorJsonHasErrors } from "./Input_Fns";
import set from "lodash/set";

export const InputAge = ({
  age,
  label = "Up To Age",
  name = "UpToAge",
  required = false,
  min = 18,
  max = 120,
  onChange,
  tooltip = "",
  onError = null,
  width = 80,
  birthYear = 0,
  ...others
}) => {
  const [errors, setErrors] = useState({})

  const onBlur = (e) => {
    if (e.target.name === name) {
      let ne = structuredClone(errors)
      let err = ""
      if (!required) {
        if (age > 0 && age < min || age > max) {
          err = "0 or " + min + " to " + max
        }
      } else {
        if (age < min || age > max) {
          err = "" + min + " to " + max
        }
      }
      ne = set(ne, e.target.name, err)
      setErrors(ne)
      if (onError !== null) {
        onError(errorJsonHasErrors(ne) ? "Errors" : "")
      }

    }
  }
  return (
    <Tooltip title={tooltip} arrow>
      <TextField
        label={(label ? label : "Up To Age") + ": " + (Number(birthYear) + Number(age))}
        name={name}
        type="number"

        slotProps={{
          htmlInput: {
            min: min,
            max: max,
            step: 1,
          },
        }}
        required={required}
        onWheel={(e) => e.target instanceof HTMLElement && e.target.blur()}
        size="small"
        sx={{ width: birthYear === 0 ? width : width + 35 }}
        value={age}
        onChange={onChange}
        error={!!errors[name]}
        helperText={errors[name]}
        onBlur={onBlur}
        {...others}
      />
    </Tooltip>
  );
};
